import { extendVariants, Button } from '@heroui/react'

export const GradientButton = extendVariants(Button, {
  variants: {
    color: {
      gradient: 'gradient-button',
    },
  },
  defaultVariants: {
    color: 'gradient',
    variant: 'light',
  },
})

GradientButton.displayName = 'GradientButton'
